import { Component, OnInit } from '@angular/core';
import * as $AB from 'jquery';
declare var Razorpay: any;

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements OnInit {

    p:any;
     transactions=[
       {'sr':'1','Asset_name':'Real Estate','Asset_Type':'Data','Paid':'$24','Transaction_Time':'03/01/2020'},
        {'sr':'2','Asset_name':'Real Estate','Asset_Type':'Algorithm','Paid':'$24','Transaction_Time':'03/01/2020'},
         {'sr':'3','Asset_name':'Real Estate','Asset_Type':'Data','Paid':'$24','Transaction_Time':'03/01/2020'},
          {'sr':'4','Asset_name':'Real Estate','Asset_Type':'Algorithm','Paid':'$24','Transaction_Time':'03/01/2020'},
           {'sr':'5','Asset_name':'Real Estate','Asset_Type':'Data','Paid':'$24','Transaction_Time':'03/01/2020'},
           {'sr':'6','Asset_name':'Real Estate','Asset_Type':'Algorithm','Paid':'$24','Transaction_Time':'03/01/2020'}
   ]
  razorPayOptions = {
    "key": "rzp_test_Goaqlet7JS58Lt", // Enter the Key ID generated from the Dashboard
    "amount": "100", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "Datapitcher",
    "description": "Test Transaction",
    "image": "../../../assets/image/sideLogo.png",
     //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    "handler": function (response){
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature)
    },
 
    "notes": {
        "address": "Razorpay Corporate Office"
    },
    "theme": {
        "color": "#8000ff"
    }
};

pay(){
  console.log("a");
var rzp1 = new Razorpay(this.razorPayOptions);

    rzp1.open();
    

}
  constructor() { }

  ngOnInit(): void {
  $(".header-title p").text('Wallet');
  }

}
